<div class="panel rs-bg-grey1 clearfix">
  <h3 class="rs-tit6 rs-txt-c1 small-only-text-center">
    {{ 'mobile.pricingPlan.simInfo.title' | translate }}
  </h3>
  <div class="panel rs-bg-grey3">
    <div class="rs-flex-row rs-flex-bottom">
      <div class="rs-flex-column">
        <p class="rs-txt-purple">
          {{ 'mobile.pricingPlan.simNumber' | translate }}
        </p>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <p class="rs-txt-purple" *ngIf="hideSimCode">
          {{ 'mobile.pricingPlan.simNumber.hidden' | translate }}
        </p>
        <p class="rs-txt-purple" *ngIf="!hideSimCode">
          {{ simInfo.simCardNumber }}
        </p>
      </div>
      <div class="rs-flex-column rs-flex-shrink" (click)="toggleSimCode()">
        <p class="rs-txt-purple">
          <a
            href="javascript:void(0)"
            role="button"
            class="rs-txt-purple rs-txt-hover"
            aria-label="Display or hide Password"
          >
            <i
              class="icon-lh rs-txt-s8"
              aria-hidden="true"
              [ngClass]="{
                'icon-Eyedeficiency': !hideSimCode,
                'icon-Seealso': hideSimCode
              }"
            ></i>
          </a>
        </p>
      </div>
    </div>
    <div class="rs-flex-row rs-flex-bottom">
      <div class="rs-flex-column">
        <p class="rs-txt-purple">
          {{ 'mobile.pricingPlan.puk' | translate }}
        </p>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <p class="rs-txt-purple" *ngIf="hidePukCode">
          {{ 'mobile.pricingPlan.puk.hidden' | translate }}
        </p>
        <p class="rs-txt-purple" *ngIf="!hidePukCode">{{ simInfo.puk1 }}</p>
      </div>
      <div class="rs-flex-column rs-flex-shrink" (click)="togglePukCode()">
        <p class="rs-txt-purple">
          <a
            href="javascript:void(0)"
            role="button"
            class="rs-txt-purple rs-txt-hover"
            aria-label="Hide Password"
          >
            <i
              class="icon-lh rs-txt-s8"
              aria-hidden="true"
              [ngClass]="{
                'icon-Eyedeficiency': !hidePukCode,
                'icon-Seealso': hidePukCode
              }"
            ></i>
          </a>
        </p>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      ('sim.enable' | translate) !== 'false' && (isB2b2e$ | async) === false
    "
    class="text-right"
  >
    <a
      class="rs-btn rs-btn-third"
      [routerLink]="['/details/mobile', simInfo?.msisdn, 'sim']"
    >
      {{ "sim.manage-sim-card" | translate }}
      <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i>
    </a>
  </div>
</div>
